import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import get from 'get-value';
import {IconEdit, PrimaryIcon} from '../../common/Button';
import {fetchDistributionFullTextSearch} from '../../../actions/distribution/actionDistributionFullTextSearch';
import {editDistributionListButtonVisibility} from '../../../constants/distributionTicketRights';
import {moduleRoles} from '../../../utils/roles';
import Table from '../../common/table/TicketTable';
import formMessages from '../../../intl/modules/formMessages';
import {countryLanguageMapping} from '../../../constants/Utils';

class FullTextSearchDistributionTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchDefaultPageSizeDB: 10,
            searchDefaultSortDB: [{id: 'TICKET_NUMBER', desc: true}],
        };
        this.handleFetchData = this.handleFetchData.bind(this);
    }

    handleFetchData = state => {
        this.props.fetchDistributionFullTextSearch(
            state.pageSize,
            state.sorted,
            state.cursor,
            state.isNextFromPivot,
            this.normalizeFiltered(state));
        this.setState({
            searchDefaultPageSizeDB: state.pageSize,
            searchDefaultSortDB: state.sorted,
        });
    };


    normalizeFiltered = () => {
        return this.props.searchDefaultFiltersDB
            .map(filterItem => {
                if (filterItem.value instanceof Date) {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value).add(12, 'hours').toISOString().substr(0, 10)
                    };
                } else {
                    return filterItem;
                }
            });
    };

    render() {
        const {
            columns, data, pages, isLoading, isNextPage, isNextFromPivot, handleEditClick,
            searchDefaultFiltersDB, subjects, userDetail,
        } = this.props;
        const language = get(userDetail, 'settings.language', 'DEFAULT')
        const translatedData = data.map(oldData => ({
            ...oldData,
            subject: (subjects !== undefined && subjects !== null) ?
                countryLanguageMapping[oldData.group] === language ?
                    [get(get(subjects, `distribution.${oldData.group}`, []).find(subject => subject.uuid === oldData.subject), `languages.local`, oldData.subject) === null ?
                        get(get(subjects, `distribution.${oldData.group}`, [])
                            .find(subject => subject.uuid === oldData.subject), `languages.default`, oldData.subject) :
                        get(get(subjects, `distribution.${oldData.group}`, [])
                            .find(subject => subject.uuid === oldData.subject), `languages.local`, oldData.subject)]
                    : get(get(subjects, `distribution.${oldData.group}`, [])
                        .find(subject => subject.uuid === oldData.subject), `languages.default`, oldData.subject)
                : oldData.subject,
        }));

        return (
            <div className="container-fluid text-center mb-5">
                <div className="row">
                    <div className="col">
                        <Table
                            filterable={false}
                            columns={[{
                                id: 'TICKET_NUMBER',
                                accessor: 'ticketNumber',
                                filterable: false,
                                message: formMessages.TICKET_NUMBER,
                                Cell: row => <Link to={`view/${row.original.id}`}>{row.value}</Link>
                            }, ...columns]}
                            toolButtons={[{
                                handleClick: handleEditClick,
                                component: <PrimaryIcon className="btn btn-sm"
                                                        title="Edit"
                                                        type="button"
                                                        key="editButton">
                                    <IconEdit/>
                                </PrimaryIcon>
                            }]}
                            isLoading={isLoading}
                            data={translatedData}
                            pages={pages}
                            handleFetchData={this.handleFetchData}
                            isNextPage={isNextPage}
                            isNextFromPivot={isNextFromPivot}
                            defaultFiltered={searchDefaultFiltersDB}
                            defaultSorting={this.state.searchDefaultSortDB}
                            defaultPageSize={this.state.searchDefaultPageSizeDB}
                            buttonVisibility={
                                editDistributionListButtonVisibility[moduleRoles.isDealerDistribution(userDetail.roles) ?
                                    'DEALER' : 'EDITOR']}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

FullTextSearchDistributionTable.propTypes = {
    columns: PropTypes.array.isRequired,
    handleEditClick: PropTypes.func.isRequired,
    searchDefaultFiltersDB: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    pages: PropTypes.number.isRequired,
    isNextPage: PropTypes.bool.isRequired,
    isNextFromPivot: PropTypes.bool.isRequired,
    fetchDistributionFullTextSearch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    data: state.distributionFullTextSearch.fullTextData,
    pages: state.distributionFullTextSearch.pages,
    isNextPage: state.distributionFullTextSearch.isNextPage,
    isNextFromPivot: state.distributionFullTextSearch.isNextFromPivot,
    isLoading: state.distributionFullTextSearch.isTableLoading,
    userDetail: state.profile.userDetail,
    subjects: state.adminSubjectSettings.subjectSettings.subjects,
});

export default connect(mapStateToProps, {
    fetchDistributionFullTextSearch
})(FullTextSearchDistributionTable)
